import React, {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {getIdPortalHost} from "../../utils/Common";
import axios from "axios";

const axiosInstance = axios.create();

export default function ErrorHandler() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {

        const reportErrorAndRedirect = async () => {
            const invalidPath = location.pathname + location.search;
            const response = await axiosInstance.post(
                `${window.location.protocol}//${getIdPortalHost()}/ui-error`,
                {path: invalidPath});
            const errorMessage = btoa(response.data?.errorMessage);
            navigate('/login?error=' + errorMessage, {replace: true});
        };

        reportErrorAndRedirect();
    }, [location, navigate]);

    return <p>Redirecting...</p>;
}